import { Facebook, Instagram, Twitter, Mail, Phone, MapPin, Heart } from 'lucide-react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.png';
import hashtagTitle from '../assets/title.png';
import './Footer.css';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="footer">
            <div className="container">
                <div className="footer-top">
                    {/* Brand */}
                    <div className="footer-brand">
                        <div className="footer-logo-wrapper">
                            <img src={logo} alt="Hashtag PG Logo" className="footer-logo" />
                            <img src={hashtagTitle} alt="Hashtag PG" className="footer-title" />
                        </div>
                        <p className="footer-description">
                            Redefining urban living with premium PGs and flats designed for comfort, community, and convenience.
                        </p>
                        <div className="footer-social">
                            <a href="#" className="footer-social-link" aria-label="Facebook">
                                <Facebook size={20} />
                            </a>
                            <a href="#" className="footer-social-link" aria-label="Instagram">
                                <Instagram size={20} />
                            </a>
                            <a href="#" className="footer-social-link" aria-label="Twitter">
                                <Twitter size={20} />
                            </a>
                        </div>
                    </div>

                    {/* Quick Links */}
                    <div className="footer-links">
                        <h4 className="footer-heading">Quick Links</h4>
                        <nav className="footer-nav">
                            <Link to="/" className="footer-link">Home</Link>
                            <Link to="/listings" className="footer-link">Our Collection</Link>
                            <Link to="/about" className="footer-link">About Us</Link>
                            <Link to="/contact" className="footer-link">Contact</Link>
                        </nav>
                    </div>

                    {/* Contact */}
                    <div className="footer-contact">
                        <h4 className="footer-heading">Contact Us</h4>
                        <div className="footer-contact-list">
                            <div className="footer-contact-item">
                                <MapPin size={18} className="footer-icon" />
                                <span>Hinjawadi, Pune, Maharashtra 411057</span>
                            </div>
                            <div className="footer-contact-item">
                                <Phone size={18} className="footer-icon" />
                                <a href="tel:+919640888898">+91 96408 88898</a>
                            </div>
                            <div className="footer-contact-item">
                                <Mail size={18} className="footer-icon" />
                                <a href="mailto:hashtagstaycomfort@gmail.com">hashtagstaycomfort@gmail.com</a>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="footer-bottom">
                    <p className="footer-copyright">
                        © {currentYear} Hashtag PG Services. Made with <Heart size={14} className="footer-heart" /> in Pune.
                    </p>
                    <div className="footer-legal">
                        <Link to="/privacy" className="footer-legal-link">Privacy Policy</Link>
                        <span className="footer-divider">•</span>
                        <Link to="/terms" className="footer-legal-link">Terms of Service</Link>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
